import LocalStorageService from '@application/common/local-storage-service';
import axios from 'axios';
import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { config } from '@application/common/static-config';
const { baseURL } = config;
const login = () => {
    const msAccesstoken = LocalStorageService.getMSAccessToken();
    const accessToken = LocalStorageService.getAccessToken();
    if (!msAccesstoken) {
        throw new Error('MS Access Token is not available');
    }
    return axios.post(`${baseURL}auth/token`, null, {
        headers: {
            Authorization: `Bearer ${msAccesstoken}`,
            XAuthorization: `Bearer ${accessToken}`
        }
    });
};
const getRefreshToken = (refreshToken) => {
    return vdkEmHappinessPortalApi.post('auth/refreshToken', refreshToken);
};
const verifyToken = (refreshToken) => {
    return vdkEmHappinessPortalApi.post('token/verify-token', refreshToken);
};
const AuthApi = {
    login,
    getRefreshToken,
    verifyToken
};
export default AuthApi;
